import { useTranslation } from 'react-i18next';

/** Inline SVG icons — small footprint, no extra deps */

const TruckIcon = () => (
  <svg className="w-3.5 h-3.5 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="3" width="15" height="13" /><polygon points="16 8 20 8 23 11 23 16 16 16 16 8" /><circle cx="5.5" cy="18.5" r="2.5" /><circle cx="18.5" cy="18.5" r="2.5" />
  </svg>
);

const ReturnIcon = () => (
  <svg className="w-3.5 h-3.5 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
  </svg>
);

const HandIcon = () => (
  <svg className="w-3.5 h-3.5 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const LockIcon = () => (
  <svg className="w-3 h-3 flex-shrink-0" viewBox="0 0 16 16" fill="currentColor">
    <path fillRule="evenodd" d="M8 1a3.5 3.5 0 0 0-3.5 3.5V7H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-.5V4.5A3.5 3.5 0 0 0 8 1zm2 6V4.5a2 2 0 1 0-4 0V7h4z" />
  </svg>
);

const ProductTrustSignals = () => {
  const { t } = useTranslation();

  return (
    <div className="border-t border-gray-200 dark:border-brand-charcoal pt-4 space-y-2.5">
      {/* Trust points */}
      <div className="flex flex-col gap-1.5 text-xs text-gray-500 dark:text-gray-400">
        <div className="flex items-center gap-2">
          <TruckIcon />
          <span>{t('trust.freeShippingShort')}</span>
        </div>
        <div className="flex items-center gap-2">
          <ReturnIcon />
          <span>{t('trust.easyReturns')}</span>
        </div>
        <div className="flex items-center gap-2">
          <HandIcon />
          <span>{t('trust.handcraftedInRome')}</span>
        </div>
      </div>

      {/* Payment methods + secure checkout — single muted line */}
      <div className="flex items-center gap-2 text-[10px] text-gray-400 dark:text-gray-500 tracking-wide">
        <LockIcon />
        <span className="uppercase">Visa</span>
        <span className="text-gray-300 dark:text-gray-600">|</span>
        <span className="uppercase">Mastercard</span>
        <span className="text-gray-300 dark:text-gray-600">|</span>
        <span className="uppercase">Amex</span>
        <span className="text-gray-300 dark:text-gray-600">|</span>
        <span className="uppercase">Apple Pay</span>
        <span className="text-gray-300 dark:text-gray-600">|</span>
        <span className="uppercase">Google Pay</span>
      </div>
    </div>
  );
};

export default ProductTrustSignals;
